import React from 'react';
import { Form, Input, Modal, notification, Spin, Radio } from 'antd';
import { axius, func } from 'utils';
import { InAppBrowser } from '@capacitor/inappbrowser';
import { Button } from 'react-bootstrap';

interface Props {
	fund: boolean;
	history: any;

	setFund: (b: boolean) => void;
}
const FormWallet = (props: Props) => {
	const [form] = Form.useForm();

	const [loading, setLoading] = React.useState(false);

	const submit = (v: any) => {
		v['type'] = 'WALLET';
		v['description'] = `Wallet funding`;
		setLoading(true);
		axius.post(`payments`, v).then(async (res) => {
			if (res.status === 201) {
				if (func.isMobile) {
					await InAppBrowser.openInWebView(res.checkoutUrl);
					await InAppBrowser.addListener(
						'browserPageNavigationCompleted',
						async (data) => {
							if (data.url?.includes('/webhook/')) {
								await InAppBrowser.close();
								props.history.replace(
									`/webhook/${data.url.replace('https://', '').split('/')[2]}`
								);
								// window.location.reload();
							}
						}
					);
				} else {
					func.redirect(res.checkoutUrl);
				}
			} else {
				notification.error(res);
				setLoading(false);
			}
		});
	};

	const close = () => {
		form.resetFields();
		props.setFund(false);
	};

	return (
		<React.Fragment>
			<Modal
				open={props.fund}
				title="Fund Wallet"
				width="85vw"
				centered
				footer={null}
				onCancel={close}
			>
				<Spin
					spinning={loading}
					indicator={
						<span>
							<i className="fa fa-spin fa-circle-notch" />
						</span>
					}
				>
					<Form
						form={form}
						layout="vertical"
						onFinish={submit}
						className="pt-4"
					>
						<Form.Item
							name="amount"
							label="Amount to top-up"
							rules={[func.requiredInput]}
						>
							<Input type="number" size="large" prefix="₦" />
						</Form.Item>
						<div className="d-flexs mb-4">
							<Radio.Group
								options={[1000, 5000, 10000].map((value) => {
									return {
										value,
										label: `₦${func.numberFormat(value)}`,
									};
								})}
								block
								optionType="button"
								buttonStyle="solid"
								onChange={(e) => form.setFieldValue('amount', e.target.value)}
							/>
						</div>
						<Button type="submit" variant="secondary btn-block btn-md mt-2">
							Submit
						</Button>
					</Form>
				</Spin>
			</Modal>
		</React.Fragment>
	);
};

export default FormWallet;
